var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChevronLeft(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.0371 6.64844C14.1379 6.64844 14.2149 6.67885 14.293 6.75684C14.3711 6.83496 14.4014 6.91179 14.4014 7.0127C14.4014 7.1136 14.3711 7.19043 14.293 7.26855L9.58594 11.9756L9.93945 12.3291L14.293 16.6816C14.3707 16.7594 14.3926 16.8265 14.3896 16.9072C14.3861 17.0012 14.3542 17.0822 14.2686 17.168C14.1905 17.246 14.1135 17.2773 14.0127 17.2773C13.9118 17.2773 13.835 17.2461 13.7568 17.168L8.8125 12.2246C8.78534 12.1974 8.76548 12.1732 8.75098 12.1523L8.72168 12.0996C8.70687 12.0641 8.69829 12.0242 8.69824 11.9756C8.69824 11.9513 8.70011 11.9287 8.7041 11.9082L8.72168 11.8506C8.73339 11.8224 8.75834 11.7798 8.8125 11.7256L13.7822 6.75684C13.8602 6.67903 13.9365 6.64851 14.0371 6.64844Z",
    fill: "black",
    stroke: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron_left.8df8e0ee7eba364b206dc9c4018186c7.svg";
export { ForwardRef as ReactComponent };